import { render, staticRenderFns } from "./SelectRol.vue?vue&type=template&id=056936c2"
import script from "./SelectRol.vue?vue&type=script&lang=js"
export * from "./SelectRol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports